/**
 * Terms and Conditions Configuration
 * 
 * Set useCustom to true to use custom T&Cs for your instance.
 * Custom T&Cs should be placed in the ./custom folder.
 * 
 * If useCustom is false, default example T&Cs from ./default are used.
 */

export const termsConfig = {
    // Set to true to use custom T&Cs from ./custom folder
    // Set to false to use default example T&Cs from ./default folder
    useCustom: false,
    
    // Organization name for display
    organizationName: "Digital Service Designer",
    
    // Contact email for T&Cs questions
    contactEmail: "legal@example.com"
};

export default termsConfig;
